module.exports = __webpack_public_path__ + "static/media/externalBooking.4eedb2ff.png";